// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-square[data-v-88018ffa]{background-color:#000;border-radius:4px;color:#a0cf77;height:48px;left:16px;position:absolute;top:16px;width:48px}.centered[data-v-88018ffa]{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.date-text[data-v-88018ffa]{line-height:0px;margin-bottom:20px;margin-top:20px;text-align:center;word-wrap:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
